import { render, staticRenderFns } from "./DanhSachCanBo.vue?vue&type=template&id=13b9845c&"
import script from "./DanhSachCanBo.vue?vue&type=script&lang=js&"
export * from "./DanhSachCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports